var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HeraConfirm',_vm._g(_vm._b({staticClass:"application-form-modal",class:{
    'loading-data': _vm.isLoading,
  }},'HeraConfirm',{
    title: _vm.isLoading
      ? ''
      : _vm.$t(
          '_web_tournaments_management_player_registration_modal_title',
          "{username}'s application form",
          {
            username: _vm.username,
          }
        ),
    cancelButtonText: _vm.$t(
      '_web_tournaments_management_player_registration_modal_back_button',
      'Back'
    ),
    confirmButtonText: false,
    isLoading: _vm.isLoading,
  },false),_vm.$listeners),[(_vm.isLoading)?[_c('HeraDummyList',{attrs:{"size":"150","icon-name":"dummy/members","text":_vm.$t('_web_loading', 'Loading...')}})]:_vm._l((_vm.rows),function(cols,index){return _c('PanelRow',{key:(index + "-" + (cols.length)),staticClass:"text-left",attrs:{"items":cols}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }